import Header from './components/Header';
import Hero from './components/Hero';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import FAQSection from './components/FAQSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CommentsSection />
        <ContactSection />
        <FAQSection />
        <UpdatesSection />
        <RankingSection />
        <IndexSection />
        <FeaturesSection />
        <AboutSection />
        <MediaSection />
        <AppSection />
        <TopicsSection />
        <CarouselSection />
        <CardsSection />
      </main>
      <Footer />
    </>
  );
}